<template>
    <div class="content">
        <ContentComponentItem
            v-for="(component, key) in data.content"
            :key="key"
            :data="component"
            :background="background"
            :has-eager-image="hasEagerImage"
            :page-type="pageType"
        />
    </div>
</template>

<script setup lang="ts">
import type { Color, ComponentContentFragment } from '@/graphql/api'

import ContentComponentItem from '@/components/cms/component/ContentComponentItem.vue'
import type { PageType } from '@/components/cms/component/content/ContentButton.vue'

defineProps<{
    data: ComponentContentFragment
    background: Color
    hasEagerImage?: boolean
    pageType: PageType
}>()
</script>

<style lang="scss" scoped>
.content {
    padding: 0 20px;
}
</style>
